<div class="setup-checklist">
    <div class="checklist-row" *ngFor="let row of rows; trackBy: trackByRow" [ngClass]="{'navigable': isNavigable(row)}"
        [attr.role]="isNavigable(row) ? 'link' : null" [attr.tabindex]="isNavigable(row) ? 0 : null"
        (click)="onRowClick(row)" (keydown.enter)="onRowClick(row)" [dataHook]="'checklist-' + row.key">
        <div class="checklist-icon" [ngClass]="{'mini': row.iconSize === 20}">
            <ng-icon [name]="row.icon"></ng-icon>
        </div>
        <div class="checklist-text">
            <div class="checklist-title-row">
                <span class="checklist-title">{{ row.title | translate }}</span>
                <span class="checklist-badge" *ngIf="row.badge">{{ row.badge | translate }}</span>
            </div>
            <div class="checklist-description">{{ row.description | translate }}</div>
        </div>
        <div class="checklist-badges" *ngIf="row.image && showStoreBadges(row)" (click)="$event.stopPropagation()">
            <a [href]="appStoreUrl" target="_blank" rel="noopener"><img src="assets/images/app-download/app-store-badge.svg" alt="Download on the App Store"></a>
            <a [href]="playStoreUrl" target="_blank" rel="noopener"><img src="assets/images/app-download/google-play-badge.svg" alt="Get it on Google Play"></a>
        </div>
        <img class="checklist-image" *ngIf="row.image && !showStoreBadges(row)" [src]="row.image" [alt]="row.imageAlt || ''">
        <ng-icon class="checklist-arrow" *ngIf="!row.image && isNavigable(row)" name="heroArrowRightMini"></ng-icon>
    </div>
</div>
